






















































import { Vue, Component, Watch } from 'vue-property-decorator'
import tournamentStore from '@/modules/tournament/tournament.store'
import OverlayTabs from '@/modules/shared/components/OverlayTabs'
import AppButton from '@/modules/shared/components/AppButton'
import { TabItem } from '@/modules/shared/components/OverlayTabs/OverlayTabs.vue'
import AppSwiper from '@/modules/tournament/components/AppSwiper'
import { RawLocation } from 'vue-router'
import { getModule } from 'vuex-module-decorators'
import InstantMatchActionButtons from '@/modules/instant/components/InstantMatchActionButtons'

@Component({
  components: {
    InstantMatchActionButtons,
    OverlayTabs,
    AppButton,
    AppSwiper
  }
})
export default class OverlayTournamentCatalog extends Vue {
  items: TabItem[] = []
  tournamentModule = getModule(tournamentStore, this.$store)

  currentTab: number = 1

  /* Hooks */
  created() {
    this.assignTabs()
  }

  /* Watchers */
  @Watch('$route')
  onRouteChanged() {
    this.updateDefaultTab()
  }

  @Watch('isMobile')
  onIsMobileChanged(value: boolean) {
    this.assignTabs()
  }

  /* Methods */
  tabItemOrder(a: TabItem, b: TabItem) {
    if (!a.order || !b.order) return 0
    if (a.order < b.order) return -1
    if (a.order > b.order) return 1
    return 0
  }

  tabItemMobileOrder(a: TabItem, b: TabItem) {
    if (!a.mobileOrder || !b.mobileOrder) return 0
    if (a.mobileOrder < b.mobileOrder) return -1
    if (a.mobileOrder > b.mobileOrder) return 1
    return 0
  }

  updateDefaultTab() {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].slot === this.$route.meta.defaultTab) {
        this.currentTab = i + 1
      }
    }
  }

  assignTabs() {
    let items: any[] = [
      {
        name: this.$t('OverlayTournamentCatalog.Featured'),
        slot: 'featured',
        icon: 'star',
        to: {
          name: 'Landing'
        } as RawLocation,
        order: 1,
        mobileOrder: 1
      },
      {
        name: this.$t('OverlayTournamentCatalog.Active'),
        slot: 'active',
        icon: 'fire',
        to: {
          name: 'ActiveTournamentCatalog'
        } as RawLocation,
        order: 2,
        mobileOrder: 2
      },
      {
        name: this.$t('OverlayTournamentCatalog.Upcoming'),
        slot: 'upcoming',
        icon: 'fast-forward',
        to: {
          name: 'UpcomingTournamentCatalog'
        } as RawLocation,
        order: 3,
        mobileOrder: 4
      },
      {
        name: this.$t('OverlayTournamentCatalog.Past'),
        slot: 'past',
        icon: 'clock',
        to: {
          name: 'PastTournamentCatalog'
        } as RawLocation,
        order: 4,
        mobileOrder: 5
      }
    ]

    items.unshift({
      name: this.$t('OverlayTournamentCatalog.SitAndGo'),
      slot: 'sng',
      backgroundHighlight: true,
      glitch: true,
      icon: 'instant-match',
      to: {
        name: 'AutomatedTournament'
      } as RawLocation,
      order: 5,
      mobileOrder: 3
    })

    if (this.$vuetify.breakpoint.mobile) {
      this.items = items.sort(this.tabItemMobileOrder)
    } else {
      this.items = items.sort(this.tabItemOrder)
    }
    this.updateDefaultTab()
  }

  navigateToTournament() {
    if (!this.currentTournament) return

    this.$router.push({
      name: 'TournamentDetailsOverview',
      params: {
        tournamentId: this.currentTournament.tournamentId
      }
    })
  }

  get environment() {
    const env = process.env.VUE_APP_MODE || process.env.NODE_ENV || ''
    if (!env || env === 'production') return ''
    return {
      name: env.toUpperCase(),
      color: env === 'development' ? 'orange' : 'yellow'
    }
  }

  async onCatalogTypeSelected(route: RawLocation) {
    try {
      await this.$router.push(route)
    } catch {
      await this.$router.push({
        name: 'Landing'
      })
      this.currentTab = 1
    }
  }

  /* Computed Properties */
  get tournaments() {
    return this.tournamentModule.tournaments.filter(
      tournament => tournament.isFeatured
    )
  }

  get currentIndex() {
    return this.tournamentModule.featuredTournamentCatalogIndex
  }

  get currentTournament() {
    if (this.currentIndex < 0) return null
    return this.tournaments[this.currentIndex]
  }

  get currentAutomatedTournament() {
    return this.tournamentModule.selectedTournament
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile
  }

  get isTournamentCheckInOverlayVisible() {
    return this.tournamentModule.isTournamentCheckInOverlayVisible
  }
}
